import { v4 as uuid } from "uuid";
import FileAPI from "@/api/FileAPI";

import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {FILES, SETTINGS} from "@/actions/globalConst";
import DB from "@/models/DB";
import {MapModel} from "@/models/PPC/Dropbox/Map";
export const initialState = {
    maps: [],
    files: [],
    selected: false,
    api_state: FILES.API_INIT,
    key: null
};



const FilesReducer = createSlice({
  name: 'files',
  initialState,
  reducers: {
    setSelectedMapRed(state, action) {
        if(action.payload?.selected) {
            state.selected = action.payload?.selected; 
            state.key = uuid().slice(0, 8);
            }
        },
        setSelectedMap2(state, action) {
            if(action.payload?.selected) {
                if(!state.selected) {
                    state.selected = Array({id: action.payload.selected.id, count: action.payload.selected.pathElements.length, path: action.payload.selected.path});
                } else {
                    let pathLength = action.payload.selected.pathElements.length;
                    let newState = Array();
                    for(let i in state.selected) {
                        if(state.selected[i].count < pathLength) {
                            let item = state.selected[i];
                            newState.push(item);
                        } 
                    }
                    newState.push({id: action.payload.selected.id, count: action.payload.selected.pathElements.length, path: action.payload.selected.path});
                    state.selected = newState;
                } 
            }
    },

    // omit existing reducers here
  },
  extraReducers(builder) {
      builder.addCase(filesInit.fulfilled, (state, action) => {
        state.api_state = FILES.API_READY;
        if(action.payload.data.maps) {
            state.maps = DB.newCollection(action.payload.data.maps, MapModel);
            
            //state.maps = action.payload.data.maps;
        }
          state.files = [];
      }).addCase(filesInit.rejected, (state, action) => {
          //    state.api_state = SETTINGS.API_E;
          state.files = [];
      }).addCase(filesInit.pending,(state, action) => {
        state.api_state = FILES.API_PENDING;
        state.files = [];
      });

      builder.addCase(getFilesForMap.fulfilled, (state, action) => {
        state.api_state = FILES.API_READY;
        //state.selected = action.payload.selected;
        if(action.payload.data.files) {
            state.files = action.payload.data.files;
        }
      });
    
      builder.addCase(uploadFile.fulfilled, (state, action) => {
        state.api_state = FILES.API_READY;
        //state.selected = action.payload.selected;
        if(action.payload.data.files) {
            state.files = action.payload.data.files;
        }
          
      }).addCase(getFilesForMap.rejected, (state, action) => {
          //    state.api_state = SETTINGS.API_E;
          state.files = [];
      }).addCase(getFilesForMap.pending,(state, action) => {
        state.api_state = FILES.API_PENDING;
        state.files = [];
      });


      builder.addCase(deleteFile.fulfilled, (state, action) => {
        state.api_state = FILES.API_READY;
        //state.selected = action.payload.selected;
        if(action.payload.data) {
            for(let i in action.payload.data.data) {
                let file = action.payload.data.data[i];
                if(file.status == 200) {
                    state.files = removeFile(file.metadata.id, state.files);
                }
            }
            //state.files = action.payload.data.files;
        }
          
      })


      
    builder.addMatcher(
      (action) => action.type.startsWith('API_SET_STORAGE_BASEMAP'),
      (state, action) => {
          state.maps = [];
          state.api_state = FILES.API_INIT;
          state.selected = false;
       });

    builder.addMatcher(
      (action) => action.type.startsWith(SETTINGS.API_DISCONNECT_DROPBOX_ACCOUNT),
      (state, action) => {
          state.maps = [];
          state.api_state = FILES.API_RELOAD;
          state.selected = false;
       });
   
    builder.addMatcher(
      (action) => action.type.endsWith('/receiveMessage'),
      (state, action) => {
        let item = JSON.parse(action.payload.event.data);
        if(item?.data?.files) {
              state.maps = [];
              state.api_state = FILES.API_INIT;
                if(item?.data) {
                    state.maps = item?.data?.files;
                    state.api_state = FILES.API_READY;
                } else {
                    state.selected = false;
                    state.files = [];
                }
            //FilesReducer.actions.filesInit();        
        }
      }
    )    

    builder.addMatcher(
      (action) => action.type == ('switchtenant/fulfilled'),
      (state, action) => {
            const data = action?.payload?.data;
              state.maps = [];
              state.api_state = FILES.API_INIT;
                if(data?.files) {
                    state.maps = data?.files;
                    state.api_state = FILES.API_READY;
                } else {
                    state.selected = false;
                    state.files = [];
                }
       });

    builder.addMatcher(
      (action) => action.type == "switchtenant/pending",
      (state, action) => {
        state.maps = [];
        state.files = [];
        state.selected = false;
        //state.api_state = FILES.API_INIT;
       })

      
  }
});

export const filesInit = createAsyncThunk(
  FILES.API_INIT,
  async (data:any = null, event) => {
    let response = null;
    try {
          response = await FileAPI.getFiles();
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const getFilesForMap = createAsyncThunk(
  FILES.API_GET_FILES_FOR_MAP,
  async (mapItem:any = null, event) => {
    let response = null;
    try {
            
          response = await FileAPI.getFilesForMap(mapItem.id);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const uploadFile = createAsyncThunk(
  FILES.API_SAVE,
  async (data:any = null, event) => {
    let response = null;
    try {
          response = await FileAPI.storeFile(data.file, data.map);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const downloadFile = createAsyncThunk(
  FILES.API_DOWNLOAD,
  async (data:any = null, event) => {
    let response = null;
    try {
          response = await FileAPI.downloadFile2(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const deleteFile = createAsyncThunk(
  FILES.API_DELETE,
  async (data:any = null, event) => {
    let response = null;
    try {
          response = await FileAPI.deleteFile(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

//export const getInvoiceAPIState = (state) => state.invoice;;
export const { setSelectedMap,setSelectedMapRed } = FilesReducer.actions;
export default FilesReducer.reducer

const removeFile = (fileId, files) => {
    files = [...files];
    for(let i in files) {
        if(files[i].id == fileId) {
            files.splice(i, 1);
            break;
        }
    }
    return files;
}